import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip, Box, CircularProgress, Stack } from '@mui/material';

const getTempoNaoApontadoColor = (valor) => {
  if (typeof valor !== 'number') return 'default';
  if (valor <= 5) return 'success'; // verde - até 5 minutos é aceitável
  if (valor <= 10) return 'warning'; // amarelo
  return 'error'; // vermelho
};

const TempoNaoApontadoContratosTable = ({ data = [], loading = false }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
        <CircularProgress size={48} thickness={4} />
      </Box>
    );
  }

  // Ordena do menor para o maior tempo (menor tempo é melhor)
  const sorted = [...data].sort((a, b) => {
    const aVal = typeof a.tempo_medio_nao_apontado === 'number' ? a.tempo_medio_nao_apontado : 99999;
    const bVal = typeof b.tempo_medio_nao_apontado === 'number' ? b.tempo_medio_nao_apontado : 99999;
    return aVal - bVal;
  });

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3, mt: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, pt: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Tempo Médio Não Apontado
        </Typography>
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, textAlign: 'center', width: 80 }}>Ranking</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Contrato</TableCell>
            <TableCell sx={{ fontWeight: 700, textAlign: 'center' }}>Tempo Médio Não Apontado</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sorted.length === 0 ? (
            <TableRow>
              <TableCell colSpan={3} align="center">
                <Typography color="text.secondary">Nenhum dado encontrado.</Typography>
              </TableCell>
            </TableRow>
          ) : (
            sorted.map((row, idx) => {
              const rank = idx + 1;
              let rankColor = undefined;
              // Menor tempo é melhor, então top 3 (menores tempos) são verdes
              if (idx === 0 || idx === 1 || idx === 2) rankColor = 'success.main';
              else if (idx >= 3 && idx <= 6) rankColor = 'warning.main';
              else if (idx >= 7) rankColor = 'error.main';
              
              const tempo = typeof row.tempo_medio_nao_apontado === 'number' 
                ? Math.round(row.tempo_medio_nao_apontado) 
                : null;
              
              return (
                <TableRow key={row.des_contrato || idx} hover>
                  <TableCell align="center" sx={{ fontWeight: 700, fontSize: 18, color: rankColor }}>
                    {rank}
                  </TableCell>
                  <TableCell>{row.des_contrato}</TableCell>
                  <TableCell align="center">
                    <Chip
                      label={tempo !== null ? `${tempo} min` : '--'}
                      color={getTempoNaoApontadoColor(tempo)}
                      size="small"
                      sx={{ fontWeight: 700, minWidth: 100 }}
                    />
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TempoNaoApontadoContratosTable;

